import {Topbar} from "../Topbar/Topbar";
import {ScrollPanel} from "primereact/scrollpanel";
import {PresvalMenu} from "../Menu/PresvalMenu";
import React from "react";
import MenuRoutes from "../Route/MenuRoutes"
import VentanillaRoutes from "../Route/VentanillaRoutes";
import UserRoutes from "../Route/UserRoutes";
import OperationRoutes from "../Route/OperationRoutes";
import MaintenanceAccountsRoutes from "../Route/MaintenanceAccountsRoutes"
import BorrowerRoutes from "../Route/BorrowerRoutes";
import ContractOTCRoutes from "../Route/ContractOTCRoutes";
import packageJson from '../../../package.json';
import logoMei from "../../img/layout/LogoMEIPresval_DrawerBottom.svg";
import CommonRoutes from "../Route/CommonRoutes";
import MaintenanceRoutes from "../Route/MaintenanceRoutes";
import CorporateActionRoutes from "../Route/CorporateActionRoutes";
import CaptureGuaranteesRoutes from "../Route/CaptureGuaranteesRoutes";
import ControlPanelRoutes from "../Route/ControlPanelRoutes";
import CaptureLoanableValuesRoutes from "../Route/CaptureLoanableValuesRoutes";
import GuaranteeSelectionRoutes from "../Route/GuaranteeSelectionRoutes";
import ReportsRoutes from "../Route/ReportsRoutes";
import InvoiceRoutes from "../Route/InvoiceRoutes";
import AvailableValuesRoutes from "../Route/AvailableValuesRoutes";
import ValueTypeRoutes from "../Route/ValueTypeRoutes";
import ErrorCatch from "../../components/errorCatch/ErrorCatch";
import NotificationMessages from "../NotificationMessages";
import BilateralRoutes from "../Route/BilateralRoutes";

const Layout = ({
                    wrapperClass,
                    sidebarClassName,
                    onWrapperClick,
                    onSidebarClick,
                    onMenuItemClick,
                    onToggleMenu,
                    menu,
                    layoutMenuScroller,
                    sidebar,
                    history,
                    version
                }) => {
    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            <Topbar onToggleMenu={onToggleMenu} history={history}/>

            <div ref={(el) => sidebar = el} className={sidebarClassName} onClick={onSidebarClick}>
                <ScrollPanel ref={(el) => layoutMenuScroller = el} style={{height: '90%'}}>
                    <div className="layout-sidebar-scroll-content">
                        <PresvalMenu model={menu} onMenuItemClick={onMenuItemClick}/>
                    </div>
                </ScrollPanel>
                <div className="footer-navBar">
                    <img alt="lightBulb" src={logoMei} style={{maxWidth: "100%", maxHeight: "100%"}}/>
                    <br/>
                    Versión: {version} ({packageJson.version})
                </div>
            </div>

            <div className="layout-main">
                <ErrorCatch history = {history}>
                    <MenuRoutes/>
                    <UserRoutes/>
                    <VentanillaRoutes/>
                    <OperationRoutes/>
                    <MaintenanceAccountsRoutes/>
                    <BorrowerRoutes/>
                    <ContractOTCRoutes/>
                    <MaintenanceRoutes/>
                    <CommonRoutes/>
                    <CorporateActionRoutes/>
                    <ControlPanelRoutes/>
                    <CaptureGuaranteesRoutes/>
                    <CaptureLoanableValuesRoutes/>
                    <GuaranteeSelectionRoutes/>
                    <ReportsRoutes/>
                    <InvoiceRoutes/>
                    <AvailableValuesRoutes/>
                    <ValueTypeRoutes/>
                    <NotificationMessages />
                    <BilateralRoutes/>
                </ErrorCatch>

            </div>


            <div className="layout-mask"/>

        </div>
    );
};

export default Layout;